import React, { useState, useRef, useEffect } from "react";
import toast from "react-hot-toast";
import ACTIONS from "../Actions";
import Client from "../components/Client";
import Editor from "../components/Editor";
import { initSocket } from "../socket";
import {
	useLocation,
	useNavigate,
	Navigate,
	useParams,
} from "react-router-dom";

const EditorPage = () => {
	const socketRef = useRef(null);
	const codeRef = useRef(null);
	const location = useLocation();
	const { roomId } = useParams();
	const reactNavigator = useNavigate();
	const [clients, setClients] = useState([]);

	useEffect(() => {
		const init = async () => {
			socketRef.current = await initSocket();
			socketRef.current.on("connect_error", handleErrors);
			socketRef.current.on("connect_failed", handleErrors);

			function handleErrors(err) {
				console.log("socket error", err);
				toast.error("Socket connection failed, try again later.");
				reactNavigator("/");
			}

			socketRef.current.emit(ACTIONS.JOIN, {
				roomId,
				username: location.state?.username,
			});

			// Listening for joined event
			const handleJoined = ({ clients, username, socketId }) => {
				if (username !== location.state?.username) {
					toast.success(`${username} joined the room.`);
					console.log(`${username} joined`);
				}
				setClients(clients);
				socketRef.current.emit(ACTIONS.SYNC_CODE, {
					code: codeRef.current,
					socketId,
				});
			};
			socketRef.current.on(ACTIONS.JOINED, handleJoined);

			// Listening for disconnected
			const handleDisconnected = ({ socketId, username }) => {
				toast.success(`${username} left the room.`);
				setClients((prevClients) =>
					prevClients.filter((client) => client.socketId !== socketId)
				);
			};
			socketRef.current.on(ACTIONS.DISCONNECTED, handleDisconnected);

			// Cleanup function
			return () => {
				socketRef.current.disconnect();
				socketRef.current.off("connect_error", handleErrors);
				socketRef.current.off("connect_failed", handleErrors);
				socketRef.current.off(ACTIONS.JOINED, handleJoined);
				socketRef.current.off(ACTIONS.DISCONNECTED, handleDisconnected);
			};
		};

		init();
	}, [roomId, location.state?.username]);

	async function copyRoomId() {
		try {
			await navigator.clipboard.writeText(roomId);
			toast.success("Room ID has been copied to your clipboard");
		} catch (err) {
			toast.error("Could not copy the Room ID");
			console.error(err);
		}
	}

	function leaveRoom() {
		reactNavigator("/");
	}

	if (!location.state) {
		return <Navigate to="/" />;
	}

	return (
		<div className="mainWrap">
			<div className="aside">
				<div className="asideInner">
					<div className="logo">
						<img className="logoImage" src="/code-sync.png" alt="logo" />
					</div>
					<h3>Connected</h3>
					<div className="clientsList">
						{clients.map((client) => (
							<Client key={client.socketId} username={client.username} />
						))}
					</div>
				</div>
				<button className="btn copyBtn" onClick={copyRoomId}>
					Copy ROOM ID
				</button>
				<button className="btn leaveBtn" onClick={leaveRoom}>
					Leave
				</button>
			</div>
			<div className="editorWrap">
				<Editor
					socketRef={socketRef}
					roomId={roomId}
					onCodeChange={(code) => {
						codeRef.current = code;
					}}
				/>
			</div>
		</div>
	);
};

export default EditorPage;
